var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("RadioGroup", {
        attrs: { options: _vm.yesNoOptions },
        on: { change: _vm.emitChangeEvent },
        model: {
          value: _vm.yesNo,
          callback: function($$v) {
            _vm.yesNo = $$v
          },
          expression: "yesNo"
        }
      }),
      _vm._v(" "),
      _vm.extraDataEligible
        ? _c("div", { staticClass: "sections mt-4" }, [
            _c(
              "section",
              [
                _c("h3", [_vm._v("Wohin würdest du übersiedeln?")]),
                _vm._v(" "),
                _c("CharacteristicSelectInline", {
                  attrs: {
                    title: "Bitte wähle aus wohin du übersiedeln würdest",
                    "characteristic-type": _vm.meta.geoType,
                    "characteristic-items": _vm.geoItems,
                    "nothing-allowed": {
                      text: "Ich würde überall hin übersiedeln"
                    },
                    "show-multiple-hint": "",
                    "label-type": _vm.labelTypeApplication
                  },
                  on: { input: _vm.emitChangeEvent },
                  model: {
                    value: _vm.geo,
                    callback: function($$v) {
                      _vm.geo = $$v
                    },
                    expression: "geo"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }